<template>
    <CCol md="5">
        <CCard class="p-4">
            <CCardBody>
                <CForm>
                    <CContainer>
                        <CRow>
                            <img
                                alt="Leadgrease logo"
                                class="mb-4"
                                src="@sset/leadgrease_black.png"
                            />
                        </CRow>
                        <CRow
                            class="justify-content-center"
                            style="margin-bottom: 5%;"
                        >
                            <p
                                class="text-center text-wrap"
                                style="font-size: 0.9em;color: blueviolet; width:80%;"
                            >
                                {{ $t("start_page_text.register") }}
                            </p>
                        </CRow>
                    </CContainer>

                    <!-- <h4>{{ $t($route.name) }}</h4> -->
                    <CRow>
                        <CCol col="6">
                            <CInput
                                :lazy="false"
                                :value.sync="$v.form.first_name.$model"
                                :isValid="checkIfValid('first_name')"
                                :placeholder="`${$t('name')}`"
                                :invalidFeedback="$t('name_is_required')"
                                autocomplete="name"
                                :disabled="form._loading"
                            ></CInput>
                        </CCol>
                        <CCol col="6">
                            <CInput
                                :lazy="false"
                                :value.sync="$v.form.last_name.$model"
                                :isValid="checkIfValid('last_name')"
                                :invalidFeedback="$t('last_name_is_required')"
                                :placeholder="`${$t('lastname')}`"
                                autocomplete="lastname"
                                :disabled="form._loading"
                            ></CInput>
                        </CCol>
                    </CRow>
                    <CInput
                        type="email"
                        :lazy="false"
                        :value.sync="$v.form.email.$model"
                        :isValid="checkIfValid('email')"
                        :invalidFeedback="$t('email_is_required')"
                        :placeholder="`${$t('email')}`"
                        autocomplete="email"
                        :disabled="form._loading"
                    />
                    <PhoneNumberInput
                        :value.sync="$v.form.phone_number.$model"
                        :isValid="checkIfValid('phone_number')"
                        :disabled="form._loading"
                    />
                    <PasswordInput
                        :isValid="checkIfValid('password')"
                        :value.sync="$v.form.password.$model"
                        :placeholder="`${$t('password')}`"
                        autocomplete="new-password"
                        :under="true"
                        :disabled="form._loading"
                    ></PasswordInput>

                    <!-- <PaymentElementCard
                :instance_stripe="stripe"
                :card.sync="card"
            /> -->

                    <div class="group card-element mx-3">
                        <div class="row">
                            <div class="col-sm-12 p-0">
                                <StripeElement
                                    :instance_stripe_elements="elements"
                                    element_type="cardNumber"
                                    :value.sync="$v.form.card_number.$model"
                                    :isValid="checkIfValid('card_number')"
                                    :disabled="form._loading"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-7 p-0">
                                <StripeElement
                                    :instance_stripe_elements="elements"
                                    element_type="cardExpiry"
                                    :value.sync="$v.form.card_expiry.$model"
                                    :isValid="checkIfValid('card_expiry')"
                                    :disabled="form._loading"
                                />
                            </div>
                            <div class="col-sm-5 p-0">
                                <StripeElement
                                    :instance_stripe_elements="elements"
                                    element_type="cardCvc"
                                    :value.sync="$v.form.card_cvc.$model"
                                    :isValid="checkIfValid('card_cvc')"
                                    :disabled="form._loading"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- <CInputCheckbox
                :checked.sync="form.test_fiveteen_days"
                :label="$t('test_fiveteen_days')"
                class="mb-3"
            /> -->
                    <CButton
                        block
                        color="primary"
                        class="px-4"
                        @click="register"
                        :disabled="form._loading"
                    >
                        <CSpinner
                            class="mr-1"
                            color="light"
                            size="sm"
                            v-if="form._loading"
                        />
                        {{ $t("create_account") }}
                    </CButton>
                </CForm>
            </CCardBody>
        </CCard>
        <hr />
        <div class="small ml-auto my-auto">
            {{ $t("already_have_login_and_password") }}
            <router-link :to="{ name: 'login' }" class="">
                {{ $t("login") }}
            </router-link>
        </div>
    </CCol>
</template>

<script>
import { validationMixin } from "vuelidate";
import PhoneNumberInput from "~/components/PhoneNumberInput";
import PaymentElementCard from "~/components/elements/PaymentElementCard";
import StripeElement from "~/components/StripeElement";
import PasswordInput from "~/components/PasswordInput";
import {
    required,
    minLength,
    email,
    sameAs,
    helpers
} from "vuelidate/lib/validators";
import pageMixin from "~/mixins/page.js";
export default {
    name: "RegisterPage",

    mixins: [validationMixin, pageMixin],

    layout: "basic",

    middleware: ["guest", "import-stripe"],

    components: {
        PhoneNumberInput,
        PaymentElementCard,
        PasswordInput,
        StripeElement
    },

    metaInfo() {
        return {
            title: this.$t(this.$route.name)
        };
    },

    data: () => ({
        form: {
            first_name: "",
            last_name: "",
            email: "",
            phone_number: "",
            password: "",
            card_number: null,
            card_expiry: null,
            card_cvc: null,
            /* test_fiveteen_days:true, */
            _loading: false
            /* confirmPassword: "", */
        },
        stripe: null,
        elements: null
    }),

    computed: {
        isValid() {
            return !this.$v.form.$invalid;
        }
    },

    validations: {
        form: {
            first_name: {
                required
            },
            last_name: {
                required
            },
            email: {
                required,
                email
            },
            phone_number: {
                required,
                minLength: minLength(8)
            },
            password: {
                required,
                minLength: minLength(8),
                strongPass: helpers.regex(
                    "strongPass",
                    /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
                )
            },
            card_number: {
                required
            },
            card_expiry: {
                required
            },
            card_cvc: {
                required
            }
        }
    },

    methods: {
        async createPaymentMethod(billing_name, card) {
            return this.stripe
                .createPaymentMethod({
                    type: "card",
                    card: card,
                    billing_details: {
                        name: billing_name
                    }
                })
                .then(result => {
                    if (result.error) {
                        this.displayError(result);
                        return null;
                    } else {
                        return result.paymentMethod;
                    }
                });
        },
        async register() {
            try {
                /* let payment_method = await this.createPaymentMethod(this.form.first_name, this.card);
                this.form.paymentMethodId = payment_method.id; */

                this.form._loading = true;
                let { status } = await this.sendForm({
                    url: "/account/createV2",
                    method: "POST",
                    formatData: async form_data => {
                        let payment_method = await this.createPaymentMethod(
                            form_data.first_name,
                            form_data.card_number
                        );
                        form_data.paymentMethodId = payment_method.id;
                        delete form_data.card_number;
                        delete form_data.card_expiry;
                        delete form_data.card_cvc;
                        return form_data;
                    }
                });
                this.form._loading = false;

                if (status == true)
                    this.$router.push({
                        name: "active_account",
                        params: { email: this.form.email }
                    });
            } catch (error) {
                this.showMessageError(error);
            }
        }
    },
    async created() {
        this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
        this.elements = this.stripe.elements();
    }
};
</script>
